import React, { useState } from 'react';

import { Input } from '@eika/input';

import useTranslation from '../../../../hooks/useTranslation';
import { CrossBorderPaymentActionType } from '../form/actions';
import useFormContext from '../form/useFormContext';
import { receiverError, validateIBANNumber } from '../form/validate';

interface Props {
    validationError?: receiverError;
    setValidationError: (errors: receiverError) => void;
}

const IbanInput: React.FC<Props> = ({ validationError, setValidationError }) => {
    const translated = useTranslation();
    const { state, handleChange } = useFormContext();

    const [iban, setIban] = useState(state.receiver?.accountNumber || '');
    const [ibanError, setIbanError] = useState<string | undefined>();

    const validateIBAN = (ibanNumber: string) => {
        const validation = validateIBANNumber(translated, ibanNumber, state);
        setIbanError(validation?.iban);

        if (!validation) {
            handleChange({ type: CrossBorderPaymentActionType.SET_RECEIVER_ACCOUNT_NUMBER, payload: ibanNumber });
            handleChange({
                type: CrossBorderPaymentActionType.SET_RECEIVER_ACCOUNT_TYPE,
                payload: 'IBAN',
            });
        } else {
            handleChange({ type: CrossBorderPaymentActionType.SET_RECEIVER_ACCOUNT_NUMBER });
            handleChange({ type: CrossBorderPaymentActionType.SET_RECEIVER_ACCOUNT_TYPE });
        }
    };

    return (
        <Input
            label={translated.crossBorderPayment.newReceiver.ibanLabel}
            className="cross-border-payment__field-top"
            value={iban}
            onChange={(value) => {
                const result = value.target.value.toUpperCase().replace(/\s/g, '').trim();
                if (result.length === state.country?.ibanLength) {
                    validateIBAN(result);
                }
                setValidationError({ accountNumber: undefined });
                setIban(result);
            }}
            onBlur={() => validateIBAN(iban)}
            error={ibanError || validationError?.accountNumber}
            data-testid="IBAN-input-field"
        />
    );
};

export default IbanInput;
